var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJihanDuermeLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 126 48",
    style: {
      enableBackground: "new 0 0 126 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000029753604828423383040000001656118125838098056_);}\n\t.st1{fill:#D69AE5;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#3446C6;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 36,
    width: 50,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029011522920659533990000016529002124870954152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029011522920659533990000016529002124870954152_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,22.8c-0.2,2.4,1.6,4.6,4,4.8c1.7,0.1,14.3-0.4,14.3-0.4c1.5,0.1,2.9-1,3-2.5c0.1-1.5-1-2.9-2.5-3 c0,0-11.6-2.7-14-2.9C38.4,18.6,36.2,20.3,36,22.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.8,11c1.3-2.1,4-2.8,6-1.5c1.5,0.9,11.3,8.7,11.3,8.7c1.3,0.8,1.7,2.5,0.9,3.8c-0.8,1.3-2.5,1.7-3.8,0.9 c0,0-10.9-4.7-13-5.9C39.3,15.8,38.6,13.1,39.8,11L39.8,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,47.7c2.2,1,4.8-0.1,5.8-2.3c0.7-1.6,4-13.7,4-13.7c0.6-1.4-0.1-3-1.5-3.6c-1.4-0.6-3,0.1-3.6,1.5 c0,0-6.1,10.2-7.1,12.4C48.5,44.1,49.5,46.7,51.7,47.7L51.7,47.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,40.4c-1.6-1.8-1.4-4.6,0.4-6.2C43.5,33,54,26.1,54,26.1c1.1-1,2.9-0.9,3.9,0.3c1,1.1,0.9,2.9-0.3,3.9 c0,0-7.8,9-9.6,10.6C46.1,42.4,43.3,42.2,41.7,40.4L41.7,40.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,40.4c1.6-1.8,1.4-4.6-0.4-6.2C78.6,33,68,26.1,68,26.1c-1.1-1-2.9-0.9-3.9,0.3c-1,1.1-0.9,2.9,0.3,3.9 c0,0,7.8,9,9.6,10.6C75.9,42.4,78.7,42.2,80.3,40.4L80.3,40.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,47.7c-2.2,1-4.8-0.1-5.8-2.3c-0.7-1.6-4-13.7-4-13.7c-0.6-1.4,0.1-3,1.5-3.6c1.4-0.6,3,0.1,3.6,1.5 c0,0,6.1,10.2,7.1,12.4C73.6,44.1,72.5,46.7,70.3,47.7L70.3,47.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,22.8c0.2,2.4-1.6,4.6-4,4.8c-1.7,0.1-14.3-0.4-14.3-0.4c-1.5,0.1-2.9-1-3-2.5c-0.1-1.5,1-2.9,2.5-3 c0,0,11.6-2.7,14-2.9S85.8,20.3,86,22.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.2,11c-1.3-2.1-4-2.8-6-1.5c-1.5,0.9-11.3,8.7-11.3,8.7c-1.3,0.8-1.7,2.5-0.9,3.8c0.8,1.3,2.5,1.7,3.8,0.9 c0,0,10.9-4.7,13-5.9C82.7,15.8,83.4,13.1,82.2,11L82.2,11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.8,0.1C52.5,0.7,51,3,51.5,5.4c0.4,1.7,4.8,13.5,4.8,13.5c0.3,1.5,1.8,2.4,3.3,2.1 c1.5-0.3,2.4-1.8,2.1-3.3c0,0-1-11.8-1.6-14.2C59.6,1,57.2-0.4,54.8,0.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,0.1C69.6,0.7,71,3,70.5,5.4c-0.4,1.7-4.8,13.5-4.8,13.5c-0.3,1.5-1.8,2.4-3.3,2.1 c-1.5-0.3-2.4-1.8-2.1-3.3c0,0,1-11.8,1.6-14.2C62.5,1,64.8-0.4,67.2,0.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,33.8c5.2,0,9.4-4.2,9.4-9.4c0-5.2-4.2-9.4-9.4-9.4c-5.2,0-9.4,4.2-9.4,9.4C51.6,29.6,55.8,33.8,61,33.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61,31.9c2.5,0,4.4-3.4,4.4-7.5c0-4.1-2-7.5-4.4-7.5s-4.4,3.4-4.4,7.5C56.6,28.5,58.6,31.9,61,31.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.3,21.4l0.7,1.9c0,0.1,0.1,0.1,0.2,0.2l1.9,0.7c0.2,0.1,0.2,0.4,0,0.5l-1.9,0.7c-0.1,0-0.1,0.1-0.2,0.2 l-0.7,1.9c-0.1,0.2-0.4,0.2-0.5,0L60,25.5c0-0.1-0.1-0.1-0.2-0.2L58,24.7c-0.2-0.1-0.2-0.4,0-0.5l1.9-0.7c0.1,0,0.1-0.1,0.2-0.2 l0.7-1.9C60.8,21.1,61.2,21.1,61.3,21.4z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,23.6c0,1.6-0.3,3.1-0.9,4.5c-0.6,1.4-1.5,2.6-2.6,3.7c-1.1,1.1-2.5,1.9-4.1,2.5c-1.6,0.6-3.4,0.9-5.4,0.9 c-2,0-3.8-0.3-5.4-0.9c-1.6-0.6-3-1.5-4.1-2.5c-1.1-1.1-2-2.3-2.6-3.7c-0.6-1.4-0.9-2.9-0.9-4.5h5.5c0,0.9,0.1,1.8,0.4,2.7 c0.3,0.8,0.8,1.6,1.4,2.2c0.6,0.6,1.4,1.2,2.4,1.5c1,0.4,2.1,0.6,3.4,0.6c1.3,0,2.4-0.2,3.4-0.6c0.9-0.4,1.7-0.9,2.3-1.5 c0.6-0.6,1.1-1.4,1.4-2.2c0.3-0.9,0.5-1.8,0.5-2.7v-11h5.5V23.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,23.6c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.8-1.5-1.5-2c-0.7-0.6-1.5-1-2.5-1.4c-1-0.3-2.2-0.5-3.6-0.5h-9.5 V30h9.5c1.4,0,2.6-0.2,3.6-0.5c1-0.3,1.9-0.8,2.5-1.3c0.7-0.6,1.2-1.3,1.5-2C119.1,25.4,119.2,24.5,119.2,23.6z M125,23.6 c0,1.5-0.3,2.9-0.9,4.3c-0.6,1.3-1.5,2.5-2.7,3.5c-1.2,1-2.6,1.8-4.3,2.4c-1.7,0.6-3.7,0.8-5.9,0.8H96v-22h15.2 c2.2,0,4.2,0.3,5.9,0.9c1.7,0.6,3.2,1.3,4.3,2.4c1.2,1,2.1,2.1,2.7,3.5C124.7,20.7,125,22.1,125,23.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJihanDuermeLogoDark);
export default __webpack_public_path__ + "static/media/jihan-duerme-logo-dark.683fb339cb8e469006f0271c570619dc.svg";
export { ForwardRef as ReactComponent };